import { jsx as _jsx } from "react/jsx-runtime";
import { preventDefault } from '../../helpers';
import Icon from '../Icon';
import withStyles from '../withStyles';
import styles from './MenuBack.styles';
export const MenuBack = ({ href, onClick, classes, }) => (_jsx("a", Object.assign({ href: href, onClick: preventDefault(onClick), className: classes.root }, { children: _jsx(Icon, { icon: "arrowLeft" }) })));
export default withStyles(styles)(MenuBack);
//# sourceMappingURL=MenuBack.js.map